import { Box, Button, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { LIGHT_GREY } from "styles/oneOffColor";

import { TemplateContentType } from "features/Influencer/ContactList/schema";
import { FormAnswer } from "features/Influencer/Templates/TemplatesTable/CreateTemplate/schema";

const styles = {
  chipAnnotation: {
    backgroundColor: "#f1f3f3",
    borderRadius: 6,
    color: "green.main",
    width: "max-content",
    px: 2,
    py: 1,
    display: "block",
    margin: "auto",
    mb: 2,
  },
  card: {
    p: 3,
    border: `1px solid ${LIGHT_GREY}`,
    borderRadius: 4,
    cursor: "pointer",
    "&:hover": {
      border: `1px solid ${grey[800]}`,
    },
  },
  cardActive: {
    border: `2px solid`,
    borderColor: "primary.main",
  },
};

interface Props {
  handleSubmitForm: (form: FormAnswer) => void;
  handleBack: () => void;
  form: FormAnswer;
  setForm: React.Dispatch<React.SetStateAction<FormAnswer>>;
}

const PickTemplateTypeForm = ({
  handleSubmitForm,
  handleBack,
  form,
  setForm,
}: Props) => {
  const chooseType = (type: TemplateContentType) => {
    setForm((prev) => ({ ...prev, templateContentType: type }));
  };

  return (
    <Grid>
      <Box sx={styles.chipAnnotation}>💭 Let's answer a few questions</Box>
      <Typography
        textAlign="center"
        variant="h3"
        gutterBottom
        sx={{ textAlign: "center", fontSize: { xs: 20, md: 28 } }}
      >
        Which kind of template do you want to create?
      </Typography>

      <Grid container justifyContent="center">
        <Grid container gap={3} sx={{ my: 3, maxWidth: 800 }}>
          <Grid
            item
            xs={12}
            md
            sx={[
              styles.card,
              form.templateContentType === TemplateContentType.OUTREACH
                ? styles.cardActive
                : {},
            ]}
            onClick={() => chooseType(TemplateContentType.OUTREACH)}
          >
            <Typography variant="h4" textAlign="center">
              Outreach
            </Typography>
            <Typography textAlign="center" color="textSecondary" sx={{ mt: 2 }}>
              Your first message to a brand to introduce yourself
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            md
            sx={[
              styles.card,
              form.templateContentType === TemplateContentType.FOLLOWUP
                ? styles.cardActive
                : {},
            ]}
            onClick={() => chooseType(TemplateContentType.FOLLOWUP)}
          >
            <Typography variant="h4" textAlign="center">
              Followup
            </Typography>
            <Typography textAlign="center" color="textSecondary" sx={{ mt: 2 }}>
              A short email if they didn't reply
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justifyContent={"center"} gap={1}>
        <Button
          sx={{ px: 3, py: 1, backgroundColor: LIGHT_GREY }}
          onClick={handleBack}
          disableElevation
        >
          <Box
            component="i"
            className="fa-regular fa-circle-arrow-left"
            sx={{ mr: 1 }}
          />{" "}
          Back
        </Button>

        <Button
          sx={{ minWidth: 200, py: 1 }}
          variant="contained"
          onClick={() => handleSubmitForm(form)}
          disableElevation
          disabled={!form.templateContentType}
        >
          Next
        </Button>
      </Grid>
    </Grid>
  );
};

export default PickTemplateTypeForm;
